export default "//file.bilionpass.com/japandx-web/0.0.1/static/ai-icon.16372c92-5f821d.svg";